import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { AddonFeature, useAddon } from 'hooks/use-addon';
import { useIsAccountInEnterpriseBillingType } from 'hooks/use-enterprise';

export const useBudgetFeature = (): boolean => {
  const isEnterprise = useIsAccountInEnterpriseBillingType();
  const hasMultiBudgetAddon = useAddon(AddonFeature.MultiBudget);
  const [isMultiLineBudgetsEnabled] = useAccountFeature(
    AccountFeature.MultiLineBudgets,
  );

  if (hasMultiBudgetAddon) {
    return isMultiLineBudgetsEnabled ?? false;
  }

  return isEnterprise && (isMultiLineBudgetsEnabled ?? false);
};
